<script>
import {mapState} from 'vuex'
import axios from 'axios';
import _ from "lodash";
import { mapMutations } from "vuex";
import { _getStartAndCountOfVisiblePoints } from 'chart.js/helpers';
export default {
  name: "ProfileReports",
  data(){
    return {
      advance_reports: null,
      payments_owner: null,
      payments_utility: null,
      payments_manage: null,
      compensation_owner: null,
      sales:null,
      from_at: null,
      end_at: null,
      contract_guid:null,
      select_year_filter: 2026,
      select_month_filter: { index: 0, name: "Январь" },
      open_window: false,
      open_window_month: false,
      open_window_year: false,
      selectTypeFilter:false,
      name: '',
      tippy1:false,
      tippy2:false,
      year_filters: [2025, 2026],
      month_filters: [
        { index: 0, name: "Январь" },
        { index: 1, name: "Февраль" },
        { index: 2, name: "Март" },
        { index: 3, name: "Апрель" },
        { index: 4, name: "Май" },
        { index: 5, name: "Июнь" },
        { index: 6, name: "Июль" },
        { index: 7, name: "Август" },
        { index: 8, name: "Сентябрь" },
        { index: 9, name: "Октябрь" },
        { index: 10, name: "Ноябрь" },
        { index: 11, name: "Декабрь" }
      ]
    }
  },
  computed:{
    select_date_filter(){
      const year = this.select_year_filter;
      const monthIndex = this.select_month_filter.index;
      const monthName = this.select_month_filter.name;
      const dateStr = `${year}-${String(monthIndex + 1).padStart(2, '0')}-01`;
      return [
        `${monthName} ${year}`,
        moment(dateStr),
        moment(dateStr).endOf("month")
      ];
    },
    smartProjects(){
      var result = this.contracts
      return result
    },
    smartSumAll(){
      var result = this.payments_owner
      if(result){
        result = _.filter(result,(item)=>{

          return moment(item.invoice_begin).isBefore(this.select_date_filter.substract("days",1))
        });
      }
      return result
    },
    smartPaymentsUtilityItems(){
      let result = this.payments_utility
      if(result){
        result = _.filter(result,(item)=>{

          let start = moment(this.select_date_filter[1]).subtract(1,"months")
          let end = moment(this.select_date_filter[2]).subtract(1,"months").endOf("months")

          return moment(item.invoice_end).subtract(2,'days').isBetween(start,end,null,"[]");
        });
        return result
      }
      return result
    },
    smartPaymentsUtility(){

      return _.sumBy(this.smartPaymentsUtilityItems,"sum")

    },
    smartPaymentsManageItems(){
      let result = this.payments_manage
      if(result){
        console.log('peyem')
        console.log(result)
        result = _.filter(result,(item)=>{
          const itemDate = moment(item.invoice_end).subtract(2,"days");
          const startDate = moment(this.select_date_filter[1]).utc();
          const endDate = moment(this.select_date_filter[2]).subtract(1,'months').utc();
          
          return (itemDate.year() === startDate.year() || itemDate.month() === 0 && itemDate.year() === startDate.year() - 1) && itemDate.month() === startDate.month() && itemDate.month() === endDate.month();
        });
        console.log(result)
        return result
      }
      return result
    },
    smartPaymentsManage(){

      return  _.sumBy(this.smartPaymentsManageItems,"sum")
    },
    smartSales(){
      return _.sumBy(this.smartSalesItems,'sum')
    },
    smartSalesItems(){
      let result = this.sales
      if(result){
        result = _.filter(result,(item)=>{

          if(item.product.indexOf("Аренда недвижимости") !== -1){
            let start = moment(this.select_date_filter[1])
            let end = moment(this.select_date_filter[2]).endOf("months")

            return moment(item.sales_begin).isBetween(start,end,null,"[]");
          }
          return false
        });
        return result
      }
      return result
    },
    smartCompensationItems(){
      let result = this.compensation_owner
      if(result){
        result = _.filter(result,(item)=>{

          let start = moment(this.select_date_filter[1])
          let end = moment(this.select_date_filter[2]).endOf("months")

          return moment(item.invoice_date).isBetween(start,end,null,"[]");
        });
        return result
      }
      return result
    },
    smartCompensation(){
      var uk = document.getElementById('template-uk');
      if(this.smartCompensationItems !== null && this.smartCompensationItems.length > 0){

        if(this.tippy1 === false){
          this.tippy1 = tippy('#checkTool', {
            content: uk,
            theme: 'rented',
            trigger: 'click',
            allowHTML: true,
          })[0];
        }else{
          this.tippy1.enable()
          var text = ""
          for(var i = 0; i < this.smartCompensationItems.length; i++){
            let date = moment(this.smartCompensationItems[i]['invoice_date']).format("DD.MM.YY")
            text += "<strong>" + this.smartCompensationItems[i]['product'] + "</strong> - " + this.smartCompensationItems[i]['sum'].toLocaleString() + "р - " + date + "<br>"
          }
          this.tippy1.setContent(text)
        }
      }else{
        if(this.tippy1 !== false){
          this.tippy1.disable()
        }
      }


      return _.sumBy(this.smartCompensationItems,'sum')
    },
    smartAdvanceReportItems(){
      let result = this.advance_reports
      if(result){
        result = _.filter(result,(item)=>{

          let start = moment(this.select_date_filter[1])
          let end = moment(this.select_date_filter[2])

          return moment(item.payment_date).isBetween(start,end,null,"[]");
        });
        return result
      }
      return result
    },
    smartAdvanceReport(){
      var prochee = document.getElementById('template-prochee');
      if(this.smartAdvanceReportItems !== null && this.smartAdvanceReportItems.length > 0){
        if(this.tippy2 === false){
          this.tippy2 = tippy('#prochee', {
            content: prochee,
            theme: 'rented-birch',
            trigger: 'click',
            allowHTML: true,
          })[0];
        }else{
          this.tippy2.enable()
          var text = ""
          for(var i = 0; i < this.smartAdvanceReportItems.length; i++){
            let date = moment(this.smartAdvanceReportItems[i]['payment_date']).format("DD.MM.YY")
            text += "<strong>" + this.smartAdvanceReportItems[i]['product'] + "</strong> - " + this.smartAdvanceReportItems[i]['sum'].toLocaleString() + "р - " + date + "<br>"
          }
          this.tippy2.setContent(text)
        }
      }else{
        if(this.tippy2 !== false){
          this.tippy2.disable()
        }
      }
      return _.sumBy(this.smartAdvanceReportItems,'sum')
    },
    smartPaymentsOwner(){
      let result = this.payments_owner
      if(result){
        result = _.filter(result,(item)=>{
          let start = moment(this.select_date_filter[1])
          let end = moment(this.select_date_filter[2])

          return moment(item.invoice_begin).isBetween(start,end,null,"[]");


        });
        return _.sumBy(result,'sum')
      }
      return result
    },
    ...mapState(['user', 'contracts', 'selectContract', 'profileApiPrefix'])
  },
  methods: {
    queryGetPayments(){
      axios.get(this.profileApiPrefix + '/get-profile?to_at=2026-05-05 00:00:00&from_at=2020-05-05 00:00:00&rental_object_guid=' + this.selectContract.rental_object_guid)
          .then(response => {
            this.advance_reports = response.data.advance_report
            this.payments_owner = response.data.payments_owner
            this.payments_utility = response.data.utilityTalent
            this.payments_manage = response.data.utilityManage
            this.compensation_owner = response.data.compensation_owner
            this.sales = response.data.sales
          })
          .catch(error => {
            console.error('Ошибка при получении профиля:', error);
          });
    },
    setTypeFilter(filter){
      if(this.selectTypeFilter === filter){
        this.selectTypeFilter = false
      }else{
        this.selectTypeFilter = filter
      }
    },
    openWindowChange(){
      this.open_window_month = false
      this.open_window_year = false
      this.open_window = !this.open_window
    },
    openWindowDateChange(){
      this.open_window = false
      this.open_window_year = false
      this.open_window_month = !this.open_window_month
    },
    openWindowYearChange(){
      this.open_window = false
      this.open_window_month = false
      this.open_window_year = !this.open_window_year
    },
    clickContract(contract){
      this.setSelectContract(contract)
      this.openWindowChange()
      this.queryGetPayments()
    },
    selectMonth(month){
      this.select_month_filter = month
      this.openWindowDateChange()
    },
    selectYear(year){
      this.select_year_filter = year
      this.openWindowYearChange()
    },
    openModalSales(){
      this.setModalSales(this.smartSalesItems)
      this.$root.$refs.modals.openModal('modalSales')
    },
    ...mapMutations(['setModalSales','setSelectContract'])
  },
  mounted(){
    this.queryGetPayments()
  }
}

</script>

<template>
  <div class="profile-reports">
    <div class="filter-block left">
      <div class="filter-header left" v-if="selectContract !== null">{{selectContract.partner}}</div>
      <div class="filter-body left">
        <div class="left-filter-body left">
          <h2 class="left">выберите объект:</h2>

          <!-- <v-select
            label="Выбор контракта"
            :items="items"
            item-title="contract"
            item-text="contract"
            v-model="selectObjectKey"
          ></v-select> -->


          <div class="code_home left">
            <div class="input" @click="openWindowChange()">
              {{selectContract ? selectContract.rental_object : 'Выберите документ'}}
            </div>
            <div class="window-select" :class="{
                      'show' : open_window,
                      }">
              <span v-for="(item,keyit) in smartProjects" @click="clickContract(item)" v-bind:key="keyit" >{{item.rental_object}}</span>
            </div>
          </div>
          <!-- <div class="pencil left">
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.7281 3.82842L17.385 9.48527M14.5565 6.65684L5.36415 15.8492M5.36415 15.8492L2.53572 13.0208M5.36415 15.8492L8.19257 18.6777M7.48547 19.3848L18.7992 8.07106C19.5802 7.29001 19.5802 6.02368 18.7992 5.24263L15.9707 2.4142C15.1897 1.63315 13.9234 1.63315 13.1423 2.4142L1.82861 13.7279L1.82861 19.3848H7.48547Z"  stroke-width="2" stroke-linejoin="round"/>
            </svg>
          </div>

          <div class="search">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.6569 14.6569L19 19M8 5C10.7614 5 13 7.23858 13 10M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div> -->
        </div>

        <div class="right-filter-body">
          <span class="date">выберите год:</span>
          <div class="code_home code_home_year left">
            <div class="input" @click="openWindowYearChange()">
              {{select_year_filter ? select_year_filter : 'Выберите год'}}
            </div>
            <div class="window-select" :class="{
                      'show' : open_window_year,
                      }">
              <span v-for="(item,keyit) in year_filters" @click="selectYear(item)" v-bind:key="keyit" >{{item}}</span>
            </div>
          </div>
          <div class="code_home left">
            <div class="input" @click="openWindowDateChange()">
              {{select_month_filter ? select_month_filter.name : 'Выберите месяц'}}
            </div>
            <div class="window-select" :class="{
                      'show' : open_window_month,
                      }">
              <span v-for="(item,keyit) in month_filters" @click="selectMonth(item)" v-bind:key="keyit" >{{item.name}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="filter_sorting left">
        <div class="rent">Отчет - Аренда недвижимости</div>
        <div class="sorting">
          <span class="sorting_word left">Сортировать:</span>
          <ul class="filter">
            <li class="green-cust" :class="{'opacity' : selectTypeFilter != 'Аренда' && selectTypeFilter !== false}" @click="setTypeFilter('Аренда')">Аренда</li>
            <li class="orange-cust" :class="{'opacity' : selectTypeFilter != 'Затраты компании' && selectTypeFilter !== false}" @click="setTypeFilter('Затраты компании')">Затраты компании</li>
            <li class="yellow-cust" :class="{'opacity' : selectTypeFilter != 'Оплата' && selectTypeFilter !== false}" @click="setTypeFilter('Оплата')">Оплата УК</li>
            <li class="blue-cust" :class="{'opacity' : selectTypeFilter != 'Коммунальные' && selectTypeFilter !== false}" @click="setTypeFilter('Коммунальные')">Коммунальные</li>
            <li class="birch-cust" :class="{'opacity' : selectTypeFilter != 'Прочие' && selectTypeFilter !== false}" @click="setTypeFilter('Прочие')">Прочие услуги</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="pay_list left">
      <div class="total_block left" :class="{'opacity' : selectTypeFilter != 'Аренда'  && selectTypeFilter !== false}">
        <div class="left-top-stick">
          Итого:
        </div>
        <span class="rub_total left">{{smartPaymentsOwner ? smartPaymentsOwner.toLocaleString() : '0'}} ₽</span>
        <span class="date_between_total left">{{ select_date_filter[1].format("DD.MM.YY")}} / {{ select_date_filter[2].endOf("month").format("DD.MM.YY")}}</span>
      </div>
      <div class="price_block green left"
           :class="{
              'opacity' : selectTypeFilter !== 'Аренда' && selectTypeFilter !== false
             }"
           @click.prevent="openModalSales()"
      >
        <div class="title left">
          <div class="title-bg"></div>
          <span>Аренда недвижимости</span>
        </div>
        <span class="rub_total left">{{ smartSales ? smartSales.toLocaleString() : '0' }} ₽</span>
        <span class="date_between_total left">{{ select_date_filter[1].format("DD.MM.YY")}} / {{ select_date_filter[2].endOf("month").format("DD.MM.YY")}}</span>
        <svg class="info-circle" width="30" height="30" viewBox="0 0 30 30" fill="green" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 27.5C8.09644 27.5 2.5 21.9036 2.5 15C2.5 8.09644 8.09644 2.5 15 2.5C21.9036 2.5 27.5 8.09644 27.5 15C27.4924 21.9004 21.9004 27.4924 15 27.5ZM5 15.215C5.05915 20.7166 9.55138 25.1369 15.0532 25.1075C20.555 25.0778 24.9994 20.6094 24.9994 15.1075C24.9994 9.60563 20.555 5.13722 15.0532 5.1075C9.55138 5.07807 5.05915 9.49845 5 15V15.215ZM17.5 21.25H13.75V16.25H12.5V13.75H16.25V18.75H17.5V21.25ZM16.25 11.25H13.75V8.75H16.25V11.25Z" fill="#B2DBBF"/>
        </svg>
      </div>
      <div class="price_block blue left" :class="{'opacity' : selectTypeFilter !== 'Коммунальные' && selectTypeFilter !== false}">
        <div class="title left">
          <div class="title-bg"></div>
          <span>Коммунальные расходы</span>
        </div>
        <span class="rub_total left">{{smartPaymentsUtility ? smartPaymentsUtility.toLocaleString( ) : '0'}} ₽</span>
        <span class="date_between_total left">{{ select_date_filter[1].format("DD.MM.YY")}} / {{ select_date_filter[2].endOf("month").format("DD.MM.YY")}}</span>
      </div>
      <div class="price_block yellow left" :class="{'opacity' : selectTypeFilter != 'Оплата' && selectTypeFilter !== false}">

        <div class="title left">
          <div class="title-bg"></div>
          <span>Оплата УК</span>
        </div>
        <span class="rub_total left">{{ smartPaymentsManage ? smartPaymentsManage.toLocaleString() : "0"}} ₽</span>
        <span class="date_between_total left">{{ select_date_filter[1].format("DD.MM.YY")}} / {{ select_date_filter[2].endOf("month").format("DD.MM.YY")}}</span>
      </div>
      <div id="checkTool" class="price_block orange left" :class="{'opacity' : selectTypeFilter != 'Затраты компании' && selectTypeFilter !== false}">
        <div id="template-uk">
        </div>
        <div class="title left">
          <div class="title-bg"></div>
          <span>Затраты компании</span>
        </div>
        <span class="rub_total left">{{ smartCompensation ? smartCompensation.toLocaleString() : "0"}} ₽</span>
        <span class="date_between_total left">{{ select_date_filter[1].format("DD.MM.YY")}} / {{ select_date_filter[2].endOf("month").format("DD.MM.YY")}}</span>
      </div>
      <div id="prochee" class="price_block birch left" :class="{'opacity' : selectTypeFilter != 'Прочие' && selectTypeFilter !== false}">
        <div id="template-prochee">
        </div>
        <div class="title left">
          <div class="title-bg"></div>
          <span>Прочие услуги</span>
        </div>
        <span class="rub_total left">{{ smartAdvanceReport ? smartAdvanceReport.toLocaleString() : '0' }} ₽</span>
        <span class="date_between_total left">{{ select_date_filter[1].format("DD.MM.YY")}} / {{ select_date_filter[2].endOf("month").format("DD.MM.YY")}}</span>
      </div>
    </div>
    <!--    <div class="docs-block left">-->
    <!--      <div class="docs-title left">Документы</div>-->
    <!--      <div class="clear"></div>-->
    <!--      <div class="docs-list left">-->
    <!--        <div class="docs-contract left">-->
    <!--          <span class="docs-contract-block left">Документы по договору №5444555554 (Рихард243-24КЕ-ДУ) от 20.04.24</span>-->

    <!--          <div class="docs-buttons right">-->
    <!--            asd-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div class="docs-contract left">-->
    <!--          <span class="docs-contract-block">Документы по договору №5444555554 (Рихард243-24КЕ-ДУ) от 20.04.24</span>-->
    <!--        </div>-->
    <!--        <div class="docs-contract left">-->
    <!--          <span class="docs-contract-block">Документы по договору №5444555554 (Рихард243-24КЕ-ДУ) от 20.04.24</span>-->
    <!--        </div>-->
    <!--        <div class="docs-contract left">-->
    <!--          <span class="docs-contract-block">Документы по договору №5444555554 (Рихард243-24КЕ-ДУ) от 20.04.24</span>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<style scoped>
/*10.333*/

.wrapper-content.profile{
  width: calc(100% - 30rem);
  margin-left:15rem;
}
.code_home .input:hover{
  border: 0.194rem solid var(--firm);
  color:var(--firm);
}
.code_home .input{
  width: 100%;
  min-height: 4.0646rem;
  cursor:pointer;
  transition: border 0.175s ease,
  color 0.175s ease;
  white-space: nowrap;
}
.code_home{
  width: 29.0324rem;
  height: 4.0646rem;
  position: relative;
  margin-left: 1.7419rem;
}

.code_home .window-select span:hover{
  color:var(--firm700);
  background: var(--firm200);
}
.code_home .window-select span{
  padding:.78125rem 1rem;
  cursor:pointer;
  transition: background 0.175s ease,
  color 0.175s ease;
  border-radius: .7742rem;
  font-size: 1.3549rem;
  font-weight: 700;
}
.code_home .window-select.show{
  opacity:1;
  pointer-events: initial;
}
.code_home .window-select{
  width:calc(100% - 0.625rem * 2);
  padding:.875rem .625rem;
  position: absolute;
  left:0;
  top:calc(100% + 1.1875rem);
  background: #FAFDFF;
  border: 0.194rem solid var(--firm100);
  border-radius: 1.875rem;
  color:var(--black500);
  display:flex;
  flex-direction: column;
  gap:.7742rem;
  opacity:0;
  transition: opacity 0.175s ease;
  z-index:2;
  pointer-events: none;
}
.code_home .input:hover{
  border: 0.194rem solid var(--firm);
  color:var(--firm);
}
.code_home .input{
  width: 100%;
  min-height: 4.0646rem;
  cursor:pointer;
  transition: border 0.175s ease,
  color 0.175s ease;
}
.code_home{
  width: 29.0324rem;
  height: 4.0646rem;
  position: relative;
  margin-left: 1.7419rem;
}

footer .personal:hover{
  opacity:1;
  transition: opacity 0.3s ease;
}
footer .personal{
  position: absolute;
  left:5.806rem;
  bottom:1.7rem;
  opacity: 0.6;
  color:#fff;
}
header {
  width: 100%;
  height: 6.6774rem;
  display: flex;
  align-items: center;
}
.report:hover {
  background: var(--black500);
  color:#fff;
  transform: scale(1.12);
}
.report {
  padding: .7742rem 3.0968rem;
  border: var(--border-size-2) var(--black500);
  margin-left: 22.5485rem;
  font-size: 1.3548rem;
  font-weight: 700;
  color: var(--black500);
  cursor:pointer;
}

.wrapper{
  padding: 0 22.5485rem;
  margin-top: calc(3.0968rem - 1.7419rem);
}
.filter-header{
  height: 4.8389rem;
  padding: 0 1.9355rem;
  display:flex;
  align-items: center;
  background-color:#fbfbfb;
  font-size: 1.7419rem;
  font-weight: 600;
  border-radius: 1.4516rem 1.4516rem 0 0;
  margin-left:5rem;
}
.right-filter-body{
  margin-right: 6.9678rem;
}
.code_home_year{
  width: 4rem;
  margin-left:4.4rem;
  margin-right:6rem;
}
.left-filter-body{
  margin-left:6.0002rem;
}
.right-filter-body,
.left-filter-body{
  display:flex;
  align-items: center;
}
.left-filter-body h2{
  font-size:1.742rem;
  font-weight: 400;
}
.filter-body{
  background-color:#fbfbfb;
  width: 100%;
  height: 10.4516rem;
  display: flex;
  justify-content: space-between;
  border-radius: 2.2516rem;
}
.code_home .input{
  height: 4.0646rem;
  display: flex;
  align-items: center;
  font-size: 1.3548rem;
  font-weight: 700;
  border-radius: 1.4516rem;
  border: var(--border-size-2) var(--black500);
  padding: 0 3.0968rem 0 3.0968rem ;
}
.pencil:hover svg{
  width:2.4323rem;
  height:2.4323rem;
  stroke: var(--light100);
}
.pencil svg{
  width:2.0323rem;
  height:2.0323rem;
  stroke:#1A6BB2;
  transition: background 0.175s ease,
  width 0.175s ease,
  height 0.175s ease;
}
.pencil:hover {
  background-color: #1A6BB2;
  width:4.8rem;
  height:4.8rem;
}
.search:hover svg {
  stroke: var(--light100);
  width:1.9355rem;
  height:1.9355rem;
}
.pencil {
  width: 4.0645rem;
  height: 4.0645rem;
  border-radius: 2.9032rem;
  border: var(--border-size-2) var(--firm);
  margin-left: .7742rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.175s ease,
  width 0.175s ease,
  height 0.175s ease;
  cursor:pointer;
}
.search svg{
  width:1.9355rem;
  height:1.9355rem;
}
.search{
  width: 4.0645rem;
  height: 4.0645rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2.9032rem;
  border: var(--border-size-2) var(--firm);
  margin-left: .7742rem;
  stroke:#1A6BB2;
  transition: background 0.175s ease,
  width 0.175s ease,
  height 0.175s ease;
  cursor:pointer;
}

.search:hover {
  background-color: #1A6BB2;
  width:4.8rem;
  height:4.8rem;
}
.filter-body .date{
  margin-left:6.0002rem;
  font-size:1.7419rem;
  font-weight: 400;
}
.date {
  font-size: 1.7419rem;
  font-weight:400;
}
.between_date{
  font-size: 1.7419rem;
  font-weight: 700;
  margin-left: .9677rem;
}
.between_date.left_margin{
  margin-left:1.5484rem;
}
.date_button {
  width:17.3226rem;
  height: 4.0645rem;
  border: var(--border-size-2) var(--black500);
  border-radius: 1.4516rem;
  font-size:1.7419rem;
  font-weight: 700;
  margin-left: .7742rem;
}
.rent {
  font-size: 1.7419rem;
  font-weight: 700;
}
.sorting_word {
  font-size: 1.7419rem;
  font-weight: 700;
}
.filter_sorting .rent,
.filter_sorting .sorting{
  display: flex;
  align-items: center;
}
.filter_sorting {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 3.0968rem;

}
.filter{
  display: flex;
  justify-content: center;
  gap: .7742rem;
  margin-left: 1.5484rem;
}
.filter li.opacity{
  opacity:0.5
}
.filter li.active{
  transform:scale(0.92);
}
.filter li:hover{
  opacity:1;
}
.filter li{
  border: var(--border-size-2);
  border-radius: 2.9032rem;
  padding: 1.0645rem 1.5484rem;
  font-size:1.3548rem;
  font-weight: 700;
  cursor:pointer;
  transition: background 0.175s ease,
  opacity 0.175s ease,
  transform 0.175s ease;
}
.filter li.green-cust:hover {
  background-color: var(--green);
}
.filter li.green-cust{
  border-color: var(--green);
}
.filter li.orange-cust:hover {
  background-color: var(--orange2);
}
.filter li.orange-cust{
  border-color: var(--orange2);
}
.filter li.yellow-cust:hover{
  background-color: var(--yellow2);
}
.filter li.yellow-cust{
  border-color: var(--yellow2);
}
.filter li.blue-cust:hover {
  background-color: var(--firm200);
}
.filter li.blue-cust{
  border-color: var(--firm200);
}
.filter li.birch-cust:hover{
  background-color: var(--birch);
}
.filter li.birch-cust{
  border-color: var(--birch);
}
@media only screen and (max-width: 700px) {
  .code_home_year{
    width: 14rem;
    margin-left:4.4rem;
    margin-right:0rem;
  }
  .filter li.green-cust:hover,
  .filter li.blue-cust:hover,
  .filter li.orange-cust:hover,
  .filter li.yellow-cust:hover,
  .filter li.birch-cust:hover{
    background-color: initial;
  }
  .filter li.green-cust:active{
    background-color: var(--green);
  }
  .filter li.orange-cust:active{
    background-color: var(--orange2);
  }
  .filter li.yellow-cust:active{
    background-color: var(--yellow2);
  }
  .filter li.blue-cust:active{
    background-color: var(--firm200);
  }
  .filter li.birch-cust:active{
    background-color: var(--birch);
  }
}
.pay_list{
  width: 100%;
  display: flex;
  flex-wrap:wrap;
  gap:1.5484rem;
  margin-top:6.5807rem;
}
.total_block {
  width: calc(32.7098rem - .9677rem);
  position: relative;
  border: .4839rem solid var(--firm);
  border-radius: .2903rem 2.9032rem 2.9032rem 2.9032rem;
  margin-top:-2rem;
}

.left-top-stick{
  position: absolute;
  left:-.4439rem;
  top:-.4439rem;
  font-size:2.3226rem;
  padding: 1.3548rem 3.2903rem 1.3548rem 2.9032rem;
  background-color: var(--firm);
  color:var(--light500);
  border-radius: 0 2.9032rem 2.9032rem 2.9032rem;
  font-weight: 600;
}
.rub_total{
  width:100%;
  font-size: 3.871rem;
  font-weight: 700;
  margin-left: 3.0968rem;
  margin-top:6.271rem;
  white-space: nowrap;
  margin-right: 3.09rem;
}
.date_between_total {
  font-size: 1.7419rem;
  font-weight: 400;
  margin-left: 3.0968rem;
  margin-bottom: 1.9355rem;
  margin-right: 1.9355rem;
  white-space: nowrap;
}
.price_block .title .title-bg{
  width:calc(100% + .9677rem);
  height:100%;
  position: absolute;
  left:-0.4839rem;
  top:0;
  border-radius: 2.9032rem;
  transition: background 0.3s ease;
}
.price_block .title span{
  z-index: 1;
  font-size: 1.742rem;
  font-weight: 600;
}


.price_block .date_between_total{
  margin-top:.7742rem;
}
.price_block .rub_total{
  margin-top:1.1613rem;
  font-size: 3.0968rem;
  margin-right:3.0968rem;
}
.price_block .title{
  position: relative;
  border-radius: 2.9032rem;
  display:flex;
  justify-content: center;
  align-items: center;
  font-size:1.7419rem;
  padding:1.0645rem 3.0968rem;
  margin-top:-.4839rem;
}
.total_block.opacity,
.price_block.opacity{
  opacity:0.5;
}
.price_block{
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 2.9032rem;
  border: 0.4839rem solid;
  opacity:1;
  transition: opacity 0.175s ease, transform 0.3s ease, border 0.3s ease;
}

.price_block.green:hover .title .title-bg{
  background: #c4e4ce;
}
.info-circle{
  fill: var(--green);
  transition: fill 0.3s ease;
}

.price_block.green:hover .info-circle{
  fill: #c4e4ce;
}
.price_block.green:hover{
  transform: translatey(-1.1rem);
  border-color:rgba(178, 219, 191, 0.76);
}
.price_block.blue{
  border-color:var(--firm200);
}
.price_block.blue .title .title-bg{
  background: var(--firm200);
}
.price_block.yellow{
  border-color:var(--yellow2);
}
.price_block.yellow .title .title-bg{
  background: var(--yellow2);
}
.price_block.orange{
  border-color:var(--orange2);
}
.price_block.orange .title .title-bg{
  background: var(--orange2);
}
.price_block.green{
  border-color:var(--green);
}
.price_block.green .title .title-bg{
  background: var(--green);
}
.price_block.birch{
  border-color:var(--birch);
}
.price_block.birch .title .title-bg{
  background: var(--birch);
}
.docs-block {
  position: relative;
  background-color:rgba(var(--light100rgb),0.5);
  width: 100%;
  border-radius: 1.4516rem;
  margin-top: 3.0968rem;
  margin-bottom: 6rem;
}
div.theme--light.v-application{
  background-color: #F5F8F9;
  font-family: Montserrat;
}
.docs-title {
  width:24.2911rem;
  height:3.0969rem;
  position: absolute;
  top:0;
  left:3.0968rem;
  font-size: 1.7419rem;
  font-weight: 700;
  background-color: #F5F8F9;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0 0 1.4516rem 1.4516rem;
}
.docs-contract {
  width:100%;
  padding:2.4194rem 0 1.9355rem 0;
  background-color: #F5F8F9;
  border-radius:1.4516rem ;
  border-bottom: .4839rem solid var(--firm300);
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1.7419rem;
  font-weight: 700;
}

.docs-list:last-child {
  margin-bottom:3.484rem;
}
.docs-list{
  width:calc(100% - (3.0968rem * 2));
  margin-left: 3.0968rem;
  display:flex;
  flex-direction: column;
  gap: 1.5484rem;
  margin-top:6.0002rem;
}
.docs-name{
  margin-left: 4.6452rem;
}
.docs-contract-block{
  margin-left: 4.6452rem;
}
.docs-buttons svg:hover{
  stroke: #1A6BB2;
}
.docs-buttons {
  display: flex;
  gap: 1.5484rem;
  margin-right: 6rem;
  stroke: #363636;
  cursor: pointer;
  transition: stroke 0.175s ease,
  transform 0.175s ease;
}

.info-non-documents{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size:3rem;
  color:var(--firm);
}

.wrapper.non-docs{
  width: 100vw;
  height: 100vh;
  position: fixed;
  left:0;
  top:0;
  margin:0;
  background-color: #F5F8F9;
}

.wrapper-block{
  width:inherit;
  height: inherit;
}



/*10.333*/

@media only screen and (max-width: 700px) {
  
.code_home_year{
  width: 14rem;
  margin-left:4.4rem;
}
  .wrapper{
    width:100vw;
    padding: 0 1.90rem;
  }

  .wrapper-content.profile{
    width: calc(100% - 8rem);
    margin-left:4rem;
  }
  .report {
    margin-left:1.54rem;
  }
  .date_between_total{
    margin-left: 2.0968rem;
    margin-right: 0.9355rem;
    margin-bottom: 0.9355rem;
  }
  .filter_sorting{
    margin-top:1.0968rem;
  }
  .price_block .title span{
    font-size:1.442rem;
  }
  .price_block div.title{
    padding:1.0645rem 1.9068rem;
  }

  .rub_total{
    margin-left:1.4968rem;
    margin-top:5.871rem;
    font-size:2.971rem;
    margin-right: 1.4968rem;
  }

  .total_block .date_between_total{
    margin-bottom:0;
  }
  .total_block{
    width:calc(24.7098rem - .9677rem);
    margin-top:-1rem;
    transition: opacity 0.3s ease;
  }

  .date_between_total{
    font-size:1.4419rem;
  }
  .pay_list {
    margin-top:2.58rem;
  }

  /* .price_block .rub_total{
      margin-top:0.5613rem;
      font-size: 2.6968rem;
  }
  .price_block .date_between_total{
      margin-top:0;
      margin-bottom: 0.7355rem;
  } */
  .filter-body{
    width:100%;
    height: 14.4516rem;
    flex-direction: column;
    justify-content: initial;
  }
  .code_home{
    width:calc(100% - 26rem);
  }
  .right-filter-body,
  .left-filter-body{
    margin-right:2rem;
    margin-top:2rem;
    margin-left:2rem;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 1rem;
  }
  .right-filter-body .code_home{
    width: calc(50% - 12rem);
  }
  .right-filter-body .code_home_year{
    width: 10rem;
  }
  .filter-body .date{
    margin-left:0;
  }
  .between_date{
    display:none;
  }
  .code_home .input{
    justify-content: center;
    width: calc(100% - 6.4rem);
    height: 4rem;
    align-items: center;
    padding-left: 3.0968rem;
    /* padding-right: 4rem; */
    align-items: center;
    display: flex;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    /* flex-wrap: wrap; */
  }
  .filter_sorting{
    flex-direction: column;
  }
  .filter_sorting .rent{
    display:none;
  }

  .sorting ul.filter{
    margin-top:1rem;
    padding-left:0;
    margin-left:0;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .filter_sorting .sorting{
    align-items:initial;
    flex-direction: column;
  }
  .sorting_word{
    margin-top:0;
    margin-left:0.7rem;
  }
}

</style>